export function deepClone(obj) {
    if (typeof structuredClone === 'function') {
        // Use the native structuredClone if available
        return structuredClone(obj);
    } else {
        // Fallback to MessageChannel-based polyfill (synchronous behavior)
        const {port1, port2} = new MessageChannel();
        let cloned: any; // To store the deep clone
        port2.onmessage = (event) => {
            cloned = event.data; // Capture the result when cloning completes
        };
        port1.postMessage(obj);

        // Busy-wait loop to block until the message is received
        while (cloned === undefined) {
            // This ensures synchronous behavior without needing Promises
        }
        return cloned;
    }
}